import {Component, OnInit} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {
    ITCIApplication,
    ITCIApplicationDeployRequest,
    ITCIApplicationDeployResponse,
    ITCIApplicationTenancyResponse,
    TCIApplicationDeploymentMode,
    TCIApplicationDeploymentNotification,
    TCIApplicationDeploymentStatus,
    TCIAppStatusCategory,
    TCITenantAppType,
    TCITenantSelectorType
} from "@tci/common";
import * as lodash from "lodash";
import {
    BaseAppDetailMenuComponentInput,
    BaseAppDetailMenuComponentOutput
} from "../../ng-app-details/ng-app-details-menu";
import {NgToastrService} from "../../ng-shared/ng-components/ng-toastr/ng-toastr.service";
import {AbstractTCITenantComponent} from "../../ng-tenant/tci-tenant-component";
import {ITCIAppDetailsMenuOutput} from "../../ng-tenant/tci-tenant-components";
import {BaseAppHMReplaceService} from "./base-app-hm-replace.service";
import {Observable} from "rxjs";

const VAL = "val";

@Component({
    selector: TCITenantSelectorType.TCI_APP_DETAIL_REPLACE_APPLICATION.toString(),
    templateUrl: "./base-app-hm-replace.component.html",
    styleUrls: ["./base-app-hm-replace.component.less"]
})
export class BaseAppHMReplaceComponent<E, I extends BaseAppDetailMenuComponentInput,
    O extends BaseAppDetailMenuComponentOutput<ITCIAppDetailsMenuOutput>>
    extends AbstractTCITenantComponent<E, I, O>
    implements OnInit {

    constructor(
        private replaceService: BaseAppHMReplaceService,
        private translate: TranslateService,
        private toastr: NgToastrService) {
        super();
    }

    private targetApp: ITCIApplication;  // from Input
    private targetAppStatusCodeClass: string;

    private modalContent = {
        replaceHint: "",
        replaceMessage: "",
        replaceConfirmMsg: "",
        confirmedAppName: "",
        targetAppName: "",
        sourceAppName: ""
    };
    private sourceApps: IReplaceSource[];
    private filteredSourceApps: IReplaceSource[];
    private selectedSourceApp: ITCIApplication;

    private loadingSource: boolean;
    /**
     * Replacement pattern:
     *   Mock from BW/FLOGO/NODE
     *   BW from BW
     *   FLOGO from FLOGO
     *   NODE from NODE
     */
    ngOnInit(): void {
        this.loadingSource = true;

        const inputObj = this.input as BaseAppDetailMenuComponentInput;
        const targetAppUserId = inputObj.application.owner;

        this.targetApp = inputObj.application;

        const thisObj = this;
        const desiredInstance = inputObj.application.desiredInstanceCount;
        this.replaceService.getAppStatus(this.targetApp.id, desiredInstance).subscribe(
            (rsp) => {
                if (!rsp.success) {
                    thisObj.targetAppStatusCodeClass = "error";
                } else {
                    if (inputObj.application.info && inputObj.application.info.num_instances > 0) {
                        thisObj.targetAppStatusCodeClass = (rsp.failedInstances > 0) ? "error" : "running";

                    } else {
                        thisObj.targetAppStatusCodeClass = "stopped";
                    }
                }
            }, (err) => {
                thisObj.targetAppStatusCodeClass = "error";
            }
        );

        this.replaceService.getSourceAppList(targetAppUserId).subscribe(
            (apps: ITCIApplication[]) => {

                const targetAppType = thisObj.targetApp.type;
                const filtedApps = lodash.filter(apps, (app: ITCIApplication) => {



                    // const val = (targetAppType.equals(app.type)) && thisObj.targetApp.id !== app.id;
                    // console.log("For app " + app.id + ", is " + val);
                    // tslint:disable-next-line: no-string-literal
                    return (targetAppType[VAL] === app.type[VAL]) && thisObj.targetApp.id !== app.id

                        && app.info
                        && app.info.endpointIds && app.info.endpointIds.length > 0
                        && !app.info.isPackaged;
                });

                thisObj.sourceApps = [];
                filtedApps.forEach((filterApp) => {
                    const sourceApp: IReplaceSource = {
                        id: filterApp.id,
                        name: filterApp.name,
                    };
                    // if (filterApp.info && filterApp.info.num_instances > 0) {
                    //     sourceApp.statusCodeClass = "running";
                    // } else {
                    //     sourceApp.statusCodeClass = "stopped";
                    // }

                    thisObj.sourceApps.push(sourceApp);

                });

                thisObj.filteredSourceApps = thisObj.sourceApps;
                thisObj.loadingSource = false;
            }, (err) => {
                console.log("Fail to get souce app list for replacing: " + err);
                thisObj.loadingSource = false;
            }
        );

        this.translate.get("TCI_HM_REPLACE_APP.APP_REPLACEMENT_TIPS", {
            targetAppType: this.getTenantApp(this.targetApp.type)
        }).subscribe((res: string) => {
            this.modalContent.replaceHint = res;
        });
    }

    getTenantApp(appType) {
        return TCITenantAppType.getDisplayName(appType);
    }

    /**
     * Select source app event
     * @param app
     */
    selectAnExistingApp(app) {
        this.selectedSourceApp = app;
        // this.translate.get("TCI_HM_REPLACE_APP.REPLACE_MESSAGE", {
        //     targetAppName: "TargetApp",
        //     sourceAppName: this.selectedSourceApp.name
        // }).subscribe((res: string) => {
        //     this.modalContent.replaceMessage = res;
        // });
        this.modalContent.targetAppName = this.targetApp.name;
        this.modalContent.sourceAppName = this.selectedSourceApp.name;
        this.modalContent.replaceConfirmMsg = this.translate.instant("TCI_HM_REPLACE_APP.REPLACE_CONFIRM");
    }

    /**
     * Search source apps
     * @param value
     */
    searchApp(value: string) {
        if (value) {
            this.filteredSourceApps = this.sourceApps.filter(sourceApp => {
                return sourceApp.name.toLowerCase().indexOf(value.toLowerCase()) >= 0;
            });
        } else {
            this.filteredSourceApps = this.sourceApps;
        }
    }

    /**
     * Go back to source app list page
     */
    goBackToSelectApp() {
        this.loadingSource = false;
        this.selectedSourceApp = undefined;
    }

    /**
     * Replace app event
     */
    replaceApp() {
        const inputObj = this.input as BaseAppDetailMenuComponentInput;

        const thisObj = this;
        const replaceAction = this.replaceService.replaceApp(inputObj.tenantAppType, this.targetApp.id, this.selectedSourceApp.id);

        const reqData: ITCIApplicationDeployRequest = {
            application: this.targetApp,
            mode: TCIApplicationDeploymentMode.MODE_APP_DETAILS,
            appId: this.targetApp.id
        };

        const scaleStatusCallBack = (cinput: ITCIApplicationDeployRequest): Observable<ITCIApplicationDeployResponse> => {
            return Observable.create(obs => {
                replaceAction.subscribe((rsp: ITCIApplicationTenancyResponse) => {
                    thisObj.toastr.clear();
                    thisObj.toastr.success(rsp.msg);
                    thisObj.closeModal(true);

                    // app is scaling
                    const cbResponse: ITCIApplicationDeployResponse = {
                        success: true,
                        status: new TCIApplicationDeploymentStatus("Scaling", TCIAppStatusCategory.IN_PROGRESS),
                        notificationType: TCIApplicationDeploymentNotification.NOTIFICATION_RESULT_APP_CHANGES,
                        appId: thisObj.targetApp.id
                    };
                    obs.next(cbResponse);
                    obs.complete();
                }, (err) => {
                    thisObj.toastr.clear();
                    thisObj.toastr.error(err.json().msg || err.json().result.errorMsg);
                    thisObj.closeModal(false);
                });
            });
        };

        this.replaceService.getTenantDeployProvider(this.targetApp.type).pushAppChanges(reqData, scaleStatusCallBack)
            .subscribe(appStatus => {
                // Note: when notification type is 0(refresh), it means scaling finished, scaling status is false.
                if (appStatus.notificationType === TCIApplicationDeploymentNotification.NOTIFICATION_REFRESH) {
                    // this.toastr.info("App scaling is done.");
                }
            });

    }

    /**
     * cancel and close modal
     */
    cancel() {
        this.closeModal();
    }

    protected closeModal(refresh = false): ITCIAppDetailsMenuOutput {
        const e: ITCIAppDetailsMenuOutput = {
            menuItemSelector: this.input.componentSelector,
            closeModal: true,
            refresh
        };
        this.output.emit(e);
        return e;
    }
}

interface IReplaceSource {
    id: string;
    name: string;
    statusCodeClass?: string;
}
